import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './UserCollectionLink.css';

/**
 * A component that displays a link to a user's collection
 */
const UserCollectionLink = ({ user, className = '' }) => {
  if (!user || !user.username) return null;
  
  return (
    <Link 
      to={`/@${user.username}/collection`} 
      className={`user-collection-link ${className}`}
    >
      {user.name}'s Collection
    </Link>
  );
};

UserCollectionLink.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  className: PropTypes.string
};

export default UserCollectionLink;